module.exports = __webpack_public_path__ + "img/bukalapak.ec3c0f3.png";